import { render } from "./QVPKidsList.vue?vue&type=template&id=863470ce&scoped=true"
import script from "./QVPKidsList.vue?vue&type=script&lang=js"
export * from "./QVPKidsList.vue?vue&type=script&lang=js"

import "./QVPKidsList.vue?vue&type=style&index=0&id=863470ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-863470ce"]])

export default __exports__